<template>
  <Modal title="Изготовленные продукты" @backdrop-click="close">
    <template slot="body">
      <ItemsPopover name="quantity_data" :list="parsedQuantityData" />
      <Preloader v-if="isLoading" type="small" />
      <div v-else class="vert-scroll table-responsive table-responsive_long-list">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="list__column">
                Название
              </th>
              <th class="list__column">
                Проект
              </th>
              <th class="list__column">
                Количество
              </th>
            </tr>
          </thead>
          <tbody class="scroll-table-body">
            <tr v-for="(product, index) in products" :key="index">
              <td class="list__row">
                <router-link
                  :to="`/products/${product.product_id}`"
                  target="_blank"
                >
                  {{ product.product_name }}
                </router-link>
              </td>
              <td class="list__row">
                <router-link
                  :to="`/projects/${product.project_id}`"
                  target="_blank"
                >
                  {{ product.project_name }}
                </router-link>
              </td>
              <td class="list__row">
                <button
                  class="row__button_unstyled"
                  v-popover:quantity_data
                  @click="showQuantityData(product)"
                >
                  {{ product.total_count }}
                  <i
                    v-if="product.total_count > 0"
                    class="fa fa-fw fa-angle-down"
                  />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template slot="footer">
      <button class="btn btn-primary" @click="close">
        Закрыть
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
import Preloader from "@/_shared/components/ui/Preloader";
import ItemsPopover from "@/_shared/components/ui/ItemsPopover";
import { analyticsService } from '@/_shared/api-services';
export default {
  emits: ['close'],
  components: {
    Modal,
    Preloader,
    ItemsPopover,
  },
  props: {
    dates: {
      type: Array,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      products: [],
      parsedQuantityData: [],
    };
  },
  async created() {
    const [startDate, endDate] = this.dates;
    const params = {
      from: startDate.toLocaleString('sv'),
      to: endDate.toLocaleString('sv'),
      user_id: this.userId,
    };
    const { data } = await analyticsService.getUserProducts(params);
    this.products = data.records;
    this.isLoading = false;
  },
  mounted() {
    document.querySelector("body").style.overflow = "hidden";
  },
  methods: {
    showQuantityData(product = {}) {
      const parsedList = JSON.parse(product.quantity_data);
      if (parsedList.length > 0) {
        this.parsedQuantityData = parsedList.map((item) => {
          const {
            international_version,
            russian_version,
            count,
          } = item;
          return `${international_version} (${russian_version}): ${count}`;
        });
      }
    },
    close() {
      document.querySelector("body").style.overflow = "auto";
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.row__button_unstyled {
  background: transparent;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/user/components/analytics/UserProductsModal.vue